<template>
    <el-form :model="questionType" :rules="rules" ref="questionType" label-width="100px">
        <el-form-item label="题型类型" prop="name">
            <el-input   v-model="questionType.name"></el-input>
        </el-form-item>
     
       
        <el-form-item label="说明" prop="description">
            <el-input v-model="questionType.description"></el-input>
        </el-form-item>
        <el-form-item>
            <el-button type="primary" @click="submitForm('questionType')">保存</el-button>
           
        </el-form-item>
    </el-form>
</template>
<script>
import AV from "leancloud-storage";
import QuestionType from "../../model/questionType"
export default {
    data() {
        return {
           
            questionType: {
              
            },
            rules: {
                
                name: [
                    { required: true, message: "请输入对应年级", trigger: "blur" },
                    { min: 3, max: 8, message: "长度在 3 到 8 个字符", trigger: "blur" }
                ],
               
                description: [
                    { required: false, message: "请输入等级说明", trigger: "blur" },
                    { min: 0, max: 200, message: "长度在 0 到 200 个字符", trigger: "blur" }
                ]
            }
        };
    },
    created() {


    },
    mounted() {
        this.getData();
    },
    watch: {
        '$route' (to, from) {

            this.getData();
        }
    },
    methods: {
        getData() {

            let id = this.$route.query.id;
            

            if (id == undefined) {
                this.questionType = new QuestionType({
                    license: this.app.license,
                    templateType: this.app.templateType,
                    creator: AV.User.current()
                }).toJSON()

            } else {
                new AV.Query(QuestionType).get(id).then(questionType => {
                    this.questionType = questionType.toJSON();
                    

                })
            }


        },
        submitForm(formName) {

            this.$refs[formName].validate(valid => {

                if (valid) {
                    
                     Object.assign(AV.Object.createWithoutData("FECQuestionType", this.questionType.objectId), AV.parseJSON(this.questionType)).save()
                        .then(
                            () => {
                                this.$message({
                                    message: '保存成功',
                                    type: 'success'
                                });
                            }
                        )
                        .catch(alert);
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        }
    }
};
</script>